module.exports = __webpack_public_path__ + "img/multiplier_free_6.7a379f97.png";